import { IAccount, IAccountPreferences, IFallbackSalutations } from '@ViewModels';

export const DEFAULT_FALLBACK_SALUTATIONS: IFallbackSalutations = {
	morning: 'Good morning',
	afternoon: 'Good afternoon',
	evening: 'Good evening',
};

export const FALLBACK_SALUTATION_MAX_LENGTH = 40;

export const FALLBACK_SALUTATION_SLOTS: (keyof IFallbackSalutations)[] = ['morning', 'afternoon', 'evening'];

/**
 * While impersonating, the session account is the staff member's own, so the greetings must come from the
 * impersonated account — and fall back to the defaults when the context carries only its id.
 */
export function resolveAccountFallbackSalutations(
	sessionAccount?: { preferences?: IAccountPreferences } | null,
	impersonationContext?: { account?: Partial<IAccount> | null } | null
): IFallbackSalutations | undefined {
	if (impersonationContext?.account?.id) {
		return impersonationContext.account.preferences?.fallbackSalutations;
	}
	return sessionAccount?.preferences?.fallbackSalutations;
}

export function getEffectiveFallbackSalutations(salutations?: IFallbackSalutations | null): IFallbackSalutations {
	return salutations ?? DEFAULT_FALLBACK_SALUTATIONS;
}

/** Mirrors the API's validation so a bad greeting is caught before the request; the API remains the authority. */
export function getFallbackSalutationError(value: string): string | null {
	const greeting = value.trim();
	if (!greeting) {
		return 'Required';
	}
	if (greeting.length > FALLBACK_SALUTATION_MAX_LENGTH) {
		return `Must be ${FALLBACK_SALUTATION_MAX_LENGTH} characters or fewer`;
	}
	if (/[\r\n]/.test(greeting)) {
		return 'Cannot contain line breaks';
	}
	if (/[<>]/.test(greeting)) {
		return 'Cannot contain < or >';
	}
	if (greeting.includes('{{') || greeting.includes('}}')) {
		return 'Cannot contain merge fields';
	}
	if (/[,:;]$/.test(greeting)) {
		return 'Leave off trailing punctuation; the template supplies it';
	}
	return null;
}
